import React, { useState } from "react";
import styled from "styled-components";
import { Modal, Form, Button } from "react-bootstrap";
import { Box, ButtonStyled, HeadingStyled } from "../../styled/Elements";
import { useTranslation } from "react-i18next";
import ValidatedInput from "../../common/inputFields/ValidatedInput";
import { useForm } from "react-hook-form";
import PhoneInputField from "../../common/inputFields/PhoneInput";
import VisitorApi from "../../../services/api/visitorApi";
import { toast } from "react-toastify";

const ContactModal = ({ show, onHide }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const {
    register,
    control,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  const onSubmit = async (formObj) => {
    try {
      setLoading(true);
      const { code, message } = await VisitorApi.contactUs(formObj);
      if (code === 200) {
        toast.success(message);
        onHide();
        reset();
      }
      if (code === 100 || code === 204) {
        toast.error(message);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={onHide}
      centered
      style={{ zIndex: 999999 }}
    >
      <Form onSubmit={handleSubmit(onSubmit)}>
        <ModalWrapper>
          <Modal.Header closeButton className="px-0">
            <Box>
              <HeadingStyled size={""}>{t("have_a_question")}</HeadingStyled>
            </Box>
          </Modal.Header>
          <Modal.Body className="px-0">
            <ValidatedInput
              name="name"
              label={"name"}
              type="input"
              fieldType="text"
              placeholder={"name"}
              className={"w-100 mb-0 combined flex-wrap p-0"}
              register={register}
              errors={errors}
              validationRules={{
                required: true,
              }}
            />

            <ValidatedInput
              name="email"
              label={"email"}
              type="input"
              fieldType="email"
              placeholder={"email"}
              className={"w-100 mb-0 combined flex-wrap p-0"}
              register={register}
              errors={errors}
              validationRules={{
                required: true,
              }}
            />

            <PhoneInputField
              name="phone"
              label={"phone"}
              placeholder={"phone"}
              className={"w-100 mb-0 combined flex-wrap p-0"}
              register={register}
              control={control}
              validationRules={{
                required: true,
              }}
            />

            <ValidatedInput
              name="message"
              label={"Message"}
              type="textarea"
              fieldType="text"
              placeholder={"Message"}
              className={"w-100 mb-0 combined flex-wrap p-0"}
              register={register}
              errors={errors}
              validationRules={{
                required: true,
              }}
            />
          </Modal.Body>
          <Modal.Footer className="px-0">
            <Box className="d-flex justify-content-end gap-2">
              <ButtonStyled
                label={t("Cancel")}
                bg={"var(--bg)"}
                color={"var(--text)"}
                onClick={onHide}
              />
              <ButtonStyled
                type="submit"
                isLoading={loading}
                disabled={loading}
                label={t("send")}
              />
            </Box>
          </Modal.Footer>
        </ModalWrapper>
      </Form>
    </Modal>
  );
};

export default ContactModal;

const ModalWrapper = styled.div`
  margin-left: 30px;
  margin-right: 30px;
  .btn-close {
    border: 1px solid var(--text3);
    border-radius: 50%;

    :hover {
      border-color: var(--text3);
    }
  }
  @media (max-width: 576px) {
    margin-left: 20px;
    margin-right: 20px;
  }
`;
